module.exports = __webpack_public_path__ + "static/media/message-question.a2ff9981.svg";